// extracted by mini-css-extract-plugin
export default {"header":"ShopList_header__q2RUH","imageWrapper":"ShopList_imageWrapper__eCcRn","image":"ShopList_image__gL2vC","row":"ShopList_row__uquVx"};